import { Injectable } from '@angular/core';

// Ionic Modules
import { ToastController } from '@ionic/angular';
import { ToastOptions } from '@ionic/core';

// Abstracts
import { NgToastService } from '../abstracts';

@Injectable()
export class ToastService extends NgToastService {

    constructor(private toastCtrl: ToastController) {
        super();
    }

    private async create(options: ToastOptions): Promise<HTMLIonToastElement> {
        return await this.toastCtrl.create(options);
    }

    public async success(options: ToastOptions): Promise<HTMLIonToastElement> {
        const toastOptions: ToastOptions = { ...this.standardOptions, ...options, ...this.standardSuccessToastOptions };
        return await this.create(toastOptions);
    }

    public async error(options: ToastOptions): Promise<HTMLIonToastElement> {
        const toastOptions: ToastOptions = { ...this.standardOptions, ...options, ...this.standardErrorToastOptions };
        return await this.create(toastOptions);
    }

}
